export default class ResultType {
  static get Communities() {
    const configuration = {
      cssSelectorForNativeAds: '[data-list-view-element] .result__card:not([data-is-featured-listing])',
      name: 'communities',
    };

    return this.getInstance('communities', configuration);
  }

  static get Homes() {
    const configuration = {
      cssSelectorForNativeAds: '[data-list-view-element] .result__card:not([data-is-featured-listing])',
      name: 'homes',
    };

    return this.getInstance('homes', configuration);
  }

  static get Builders() {
    const configuration = {
      cssSelectorForNativeAds:
        '[data-list-view-element] .result__card:not([data-is-featured-listing]):not([data-basic-card])',
    };

    return this.getInstance('builders', configuration);
  }

  static get Locations() {
    const configuration = {
      cssSelectorForNativeAds: '[data-list-view-element] .result__card:not([data-is-featured-listing])',
      name: 'locations',
    };

    return this.getInstance('locations', configuration);
  }

  /**
   * The function returns a value from a map based on the input name.
   *
   * @param name - The name of the key in the `statusMap` object that we want to retrieve the value for.
   *
   * @returns the value of the `statusMap` object that corresponds to the `name` parameter passed to the function.
   * If `name` matches one of the keys in `statusMap`, the corresponding value is returned.
   */
  static fromKey(name) {
    const statusMap = {
      builders: ResultType.Builders,
      communities: ResultType.Communities,
      homes: ResultType.Homes,
      locations: ResultType.Locations,
    };

    return statusMap[name];
  }

  /**
   * Gets an instance of a ResultType object based on a given name.
   * If the instance does not already exist, it creates a new instance using the configuration provided.
   *
   * @param name a unique identifier used to retrieve or create an instance of the ResultType class.
   * @param configuration an object that contains various properties and values that are used to configure
   * the instance of the ResultType class that is being created.
   *
   * @returns an instance of `ResultType` that corresponds to the given `name`.
   */
  static getInstance(name, configuration) {
    configuration.name = name;

    if (!this.instances[name]) {
      this.instances[name] = new ResultType(configuration);
    }

    return this.instances[name];
  }

  /**
   * This is a constructor function that takes a configuration object as a parameter and sets the name
   * and CSS selector for native ads properties.
   * @param configuration - The `configuration` parameter is an object that contains the configuration
   * settings for the constructor. It may contain properties such as `name` and
   * `cssSelectorForNativeAds`. The `name` property is a string that represents the name of the
   * configuration, while `cssSelectorForNativeAds` is a
   */
  constructor(configuration) {
    this.name = configuration.name;
    this.cssSelectorForNativeAds = configuration.cssSelectorForNativeAds;
  }

  /**
   * Method that returns the name property of an object as a string.
   * @returns returns the `name` property of that object as a string.
   */
  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ResultType, 'instances', { value: {} });
